/** @format */

import request from '@edgeguideab/client-request';
import config from 'config.json';
import urls from 'utils/urls';
import history from 'utils/history';
import loginRedirect from './loginRedirect';

export default function checkSession({ successRedirect } = {}, props) {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch({ type: 'SESSION_CHECK_STARTED' });

    let response;
    try {
      response = await request.post(`${config.apiServer}/sessions/check`);
    } catch (errorResponse) {
      dispatch({
        type: 'SESSION_CHECK_FAILED',
        payload: {
          msg: errorResponse.body.msg || 'errors.maintenance',
          location: props.location
        }
      });
      if (
        history.location.pathname === urls.loginOTC && // TODO: Not sure if this is correct
        errorResponse.body.hasValidCredentials
      ) {
        history.push(urls.loginOTC);
        return true;
      }

      dispatch({ type: 'SESSION_LOGOUT_DONE' });
      history.replace(urls.login);
      return false;
    }

    window.localStorage.setItem('csrfToken', response.body.csrfToken);
    dispatch({ type: 'SESSION_CHECK_DONE', payload: response.body });

    const hasStartPage = state.global.get('ewmFeatures').includes('startPage');
    if (successRedirect) {
      loginRedirect({
        hasStartPageAccess: response.body.user.acl.startPage.read.length > 0,
        hasStartPage
      });
    }
    return true;
  };
}
